/**
 * Prepara un logo (instancia o categoría) antes de subirlo — HU-009-C.
 * El pedido original era "quitarle el fondo" a la imagen, pero eso requiere
 * un servicio de IA externo (no hay forma confiable de hacerlo con canvas
 * del navegador); en su lugar se exige PNG (que ya soporta transparencia
 * real, la responsabilidad de preparar el fondo queda de quien sube la
 * imagen) y se recorta automáticamente al cuadrado centrado más grande
 * posible — así un logo horizontal/vertical no queda ovalado al mostrarse
 * en los círculos de icono que ya usa toda la app (`.pe-icono`,
 * `.rw-categoria-icono`, etc.).
 */
export const recortarLogoCentrado = (archivo, tamanoSalida = 512) => new Promise((resolve, reject) => {
  if (archivo.type !== 'image/png') {
    reject(new Error('El logo debe ser una imagen PNG (así admite fondo transparente).'));
    return;
  }

  const url = URL.createObjectURL(archivo);
  const img = new Image();

  img.onload = () => {
    const lado = Math.min(img.width, img.height);
    const offsetX = (img.width - lado) / 2;
    const offsetY = (img.height - lado) / 2;

    const canvas = document.createElement('canvas');
    canvas.width = tamanoSalida;
    canvas.height = tamanoSalida;
    canvas.getContext('2d').drawImage(img, offsetX, offsetY, lado, lado, 0, 0, tamanoSalida, tamanoSalida);

    canvas.toBlob((blob) => {
      URL.revokeObjectURL(url);
      if (!blob) {
        reject(new Error('No se pudo procesar la imagen'));
        return;
      }
      resolve(new File([blob], archivo.name.replace(/\.\w+$/, '.png'), { type: 'image/png' }));
    }, 'image/png');
  };

  img.onerror = () => {
    URL.revokeObjectURL(url);
    reject(new Error('No se pudo leer la imagen'));
  };

  img.src = url;
});
